Vue.asyncComponent('cms-dashboard-issues-summary', {
    props: {
        items: {
            type: Array,
            default: () => [],
        },
    },
}, 'cms/dashboard/live/cms-dashboard-issues-summary.html');
